/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste one numeric column per group to build violin plots. A violin plot shows the full shape of each group's distribution — a mirrored kernel-density curve — with the median marked, so you can compare spread and modality, not just quartiles.`)
};

const es_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una columna numérica por grupo para crear gráficos de violín. Un gráfico de violín muestra la forma completa de la distribución de cada grupo — una curva de densidad de kernel reflejada — con la mediana marcada, para que puedas comparar la dispersión y la modalidad, no solo los cuartiles.`)
};

const de_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine numerische Spalte pro Gruppe ein, um Violin-Plots zu erstellen. Ein Violin-Plot zeigt die vollständige Form der Verteilung jeder Gruppe — eine gespiegelte Kerndichtekurve — mit markiertem Median, sodass du Streuung und Modalität vergleichen kannst, nicht nur Quartile.`)
};

const nl_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak één numerieke kolom per groep om vioolplots te maken. Een vioolplot toont de volledige vorm van de verdeling van elke groep — een gespiegelde kerndichtheidscurve — met de mediaan aangegeven, zodat je spreiding en modaliteit kunt vergelijken, niet alleen kwartielen.`)
};

const fr_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une colonne numérique par groupe pour créer des graphiques en violon. Un graphique en violon montre la forme complète de la distribution de chaque groupe — une courbe de densité par noyau reflétée en miroir — avec la médiane marquée, afin de comparer la dispersion et la modalité, pas seulement les quartiles.`)
};

const it_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una colonna numerica per gruppo per creare grafici a violino. Un grafico a violino mostra la forma completa della distribuzione di ciascun gruppo — una curva di densità kernel speculare — con la mediana indicata, così puoi confrontare dispersione e modalità, non solo i quartili.`)
};

const pt_br2_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma coluna numérica por grupo para criar gráficos de violino. Um gráfico de violino mostra o formato completo da distribuição de cada grupo — uma curva de densidade de kernel espelhada — com a mediana marcada, para você comparar dispersão e modalidade, não apenas quartis.`)
};

const pt_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma coluna numérica por grupo para construir gráficos de violino. Um gráfico de violino mostra a forma completa da distribuição de cada grupo — uma curva de densidade kernel espelhada — com a mediana assinalada, para que possa comparar a dispersão e a modalidade, não apenas os quartis.`)
};

const ja_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループごとに1つの数値列を貼り付けてバイオリンプロットを作成します。バイオリンプロットは、各グループの分布の全体的な形状 — 中心軸を挟んで鏡写しにしたカーネル密度曲線 — を中央値とともに示すため、四分位数だけでなく、広がりや最頻値の数まで比較できます。`)
};

const zh_violin_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每组粘贴一列数值数据即可生成小提琴图。小提琴图以镜像的核密度曲线展示每组分布的完整形状，并标出中位数，让你不仅能比较四分位数，还能比较离散程度和分布形态。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_intro", locale)
	if (locale === "en") return en_violin_intro(inputs)
	if (locale === "es") return es_violin_intro(inputs)
	if (locale === "de") return de_violin_intro(inputs)
	if (locale === "nl") return nl_violin_intro(inputs)
	if (locale === "fr") return fr_violin_intro(inputs)
	if (locale === "it") return it_violin_intro(inputs)
	if (locale === "pt-BR") return pt_br2_violin_intro(inputs)
	if (locale === "pt") return pt_violin_intro(inputs)
	if (locale === "ja") return ja_violin_intro(inputs)
	return zh_violin_intro(inputs)
};